/* global axios */
import ApiClient from './ApiClient';

class CustomAutomationsAPI extends ApiClient {
  constructor() {
    super('custom_automation_rules', { accountScoped: true });
  }

  clone(id) {
    return axios.post(`${this.url}/${id}/clone`);
  }

  // Run rules for a frontend-originated event (kanban move, chatbot lifecycle).
  dispatch(eventName, context) {
    return axios.post(`${this.url}/dispatch_event`, {
      event_name: eventName,
      context,
    });
  }
}

export default new CustomAutomationsAPI();
